/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* appscherm.class.ts
* 10-12-2019 - Jelmer Jellema - Spin in het Web B.V.
*
* Abstracte parent van alle appschermen. Verwacht de injector van de concrete classes
* maar weer. Omdat dat de enige manier is om DI soepel naar de baseclass te krijgen
* LET OP: dat is niet meer nodig, maar voor de
*/

import {WindowedComponent} from 'src/components/windowmanager/windowedcomponent.class';
import {Sihwlog} from 'sihw-ngx';
import {Directive, HostBinding, OnDestroy, inject} from '@angular/core';
import {ApiService} from '../../services/api/api.service';
import {Subscription} from 'rxjs';

@Directive() //nodig want classes met ng-events of angular decorators moeten gedecoreerd zin
export abstract class Appscherm extends WindowedComponent implements OnDestroy {
  //zet css class
  @HostBinding('class.appscherm') readonly _hostclass = true;


  //////////////// Alle aanwezige services ///////////////////
  protected log: Sihwlog;
  public api: ApiService = inject(ApiService); //public, zodat props als api.uid beschikbaar zijn in templates


  private subscriptions: Subscription = null; //lijst met subscriptions om te destroyen bij sluiten scherm
  //helpers met timing
  protected timing: number[] = [];


  /**
   * Constructor: gebruikt Angular inject() om vereiste services op te halen i.p.v. een Injector-parameter.
   * @param loglevel Het gewenste logniveau voor deze klasse (default 'warn')
   * @protected
   */
  protected constructor(loglevel: string = "warn")
  {
    super();

    //we maken hier alle standaardservices met inject(). Constructor-inheritance werkt dan soepel zonder Injector.
    this.log = new Sihwlog(loglevel, this.constructor.name);
  }

  ngOnDestroy() {
    //verwijder lopende subscriptions
    this.log.debug(`ngOnDestroy`, this.constructor.name);
    if (this.subscriptions) {
      this.log.debug(`Verwijderen subscriptions`);
      this.subscriptions.unsubscribe();
    }
  }
  /**
   * Voeg een subscription toe aan dit object, wordt automatisch verwijderd bij destroy
   * @param sub
   */
  protected subscription(sub: Subscription) {
    if (this.subscriptions) {
      this.subscriptions.add(sub);
    } else {
      this.subscriptions = sub;
    }
  }

  /**
   * simpele pauze + release oplossing
   * @param ms
   */
  async pauze(ms: number = 1)
  {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  /**
   * Start een nieuwe timer in debugmode
   * @protected
   */
  protected pushtimer() {
    if (this.log.effectiveLoglevel !== 'debug') {
      return;
    }
    this.timing.push(Date.now()); //bewaar deze timer
  }

  /**
   * Pop de timer en debug de tijd met het tijdsverschil
   * @param msg
   * @private
   */
  protected poptimer(msg: string) {
    if (this.log.effectiveLoglevel !== 'debug') {
      return;
    }
    let begin = this.timing.pop();
    let tijd = (Date.now() - begin) / 1000;
    if (tijd < 0.5) {
      this.log.debug(`*** TIMER ${msg}: ${tijd}`);
    } else {
      this.log.debug(`*** TIMER ${msg}: ${tijd}`);
    }
  }

    /**
     * Kopieer gegeven tekst naar klembord en toon korte feedback
     */
    async kopieerNaarKlembord(text: string) {
        try {
            if (!text || !text.toString().trim().length) {
                return;
            }
            // Probeer moderne API
            if (navigator && (navigator as any).clipboard && (navigator as any).clipboard.writeText) {
                await (navigator as any).clipboard.writeText(text);
            } else {
                // Fallback via tijdelijk input-element
                const ta = document.createElement('textarea');
                ta.value = text;
                ta.style.position = 'fixed';
                ta.style.left = '-9999px';
                document.body.appendChild(ta);
                ta.focus();
                ta.select();
                document.execCommand('copy');
                document.body.removeChild(ta);
            }
          this.api.toast('Tip: gebruik op windows ⊞+V om meerdere gekopiëerde items te plakken.', 'success', 5000, 'Gekopieerd naar klembord.');
        } catch (e) {
            this.log.error(e);
            this.api.toast('Je computer staat het automatisch kopiëren niet toe','error',5000,'Kopiëren mislukt');
        }
    }
}
